module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-jack.659afdbd.svg";